import React from "react";
import { Box, Text, UnstyledButton } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import styles from "./MobileSheets.module.css";

export interface SheetOptionProps {
  label: React.ReactNode;
  /** Muted second line (e.g. resolved dates, "Tap again to reverse"). */
  sub?: React.ReactNode;
  icon?: React.ReactNode;
  /** Makes the row a radio (date range, sort); true shows the check. */
  checked?: boolean;
  /** Right-side adornment (e.g. a direction arrow, a chevron). */
  trailing?: React.ReactNode;
  danger?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

/** One tappable row of a phone sheet: an action, or a radio choice. */
export default function SheetOption({
  label,
  sub,
  icon,
  checked,
  trailing,
  danger = false,
  disabled = false,
  onClick,
}: SheetOptionProps) {
  const radio = checked !== undefined;
  return (
    <UnstyledButton
      type="button"
      className={styles.option}
      role={radio ? "radio" : undefined}
      aria-checked={radio ? checked : undefined}
      data-danger={danger || undefined}
      disabled={disabled}
      onClick={onClick}
    >
      {radio && (
        <Box component="span" className={styles.check}>
          {checked && <IconCheck size={16} aria-hidden />}
        </Box>
      )}
      {icon && (
        <Box component="span" className={styles.optionIcon}>
          {icon}
        </Box>
      )}
      <Box component="span" className={styles.optionText}>
        <Text component="span" className={styles.optionLabel}>
          {label}
        </Text>
        {sub && (
          <Text component="span" className={styles.optionSub}>
            {sub}
          </Text>
        )}
      </Box>
      {trailing && (
        <Box component="span" className={styles.optionTrailing}>
          {trailing}
        </Box>
      )}
    </UnstyledButton>
  );
}
